import React, { useEffect, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ImageUploadForm from './_imageuploadform';
import ImageGallery from './_imagepropertygallarey';
import { useGetPropertyImageQuery } from '../../../lib/apiSlice/property/propertySlice.tsx';

const SelectedPropertyImage = () => {
    const { id } = useParams();
    //   get the data and pass the id to get the property image
    const { data: propertyImages, isLoading, isError } = useGetPropertyImageQuery({ id: id });
    const [activeTab, setActiveTab] = useState('viewImages');

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className="bg-white p-4 rounded shadow-md mt-4">
            <h2 className='mb-3'>Property Image(s)</h2>
            <div className='w-100'>
                <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
                    <Nav variant='tabs' className='flex mb-2 border-b border-gray-200'>
                        <Nav.Item className="mr-2">
                            <Nav.Link
                                eventKey='viewImages'
                                className={`
                  px-4 py-2 rounded-t
                  ${activeTab === 'viewImages'
                                        ? 'bg-primary text-white font-semibold'
                                        : 'bg-blue-50 text-dark hover:bg-blue-100'
                                    }
                  transition-colors duration-200
                  border border-b-0 border-gray-200
                  focus:outline-none
                `}
                                style={{ minWidth: 'fit-content' }}
                            >
                                View Property's Images
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link
                                eventKey='selectImages'
                                className={`
                  px-4 py-2 rounded-t
                  ${activeTab === 'selectImages'
                                        ? 'bg-primary text-white font-semibold'
                                        : 'bg-blue-50 text-dark hover:bg-blue-100'
                                    }
                  transition-colors duration-200
                  border border-b-0 border-gray-200
                  focus:outline-none
                `}
                                style={{ minWidth: 'fit-content' }}
                            >
                                Select Image For Property
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <Tab.Content>
                        <Tab.Pane eventKey='viewImages'>
                            <ImageGallery apartmentId={id} images={propertyImages?.results} />
                        </Tab.Pane>
                        <Tab.Pane eventKey='selectImages'>
                            <ImageUploadForm apartmentId={id} />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div>
        </div>
    );
};

export default SelectedPropertyImage;